module.exports = __webpack_public_path__ + "img/login-left.15ab6e67.png";